import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const whitelabelStore = useWhitelabelStore()

  if (!whitelabelStore.whitelabelData.isStarted) {
    await whitelabelStore.initStore(to.params.organizationId as string)
  }
})
